(function(){
    'use strict';
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

    function init() {
        document.querySelectorAll('.premium-product-slider').forEach(slider => {
            const sectionId = slider.dataset.sectionId;
            initializeNavigation(slider);
            slider.querySelectorAll('.premium-add-to-cart-btn').forEach(btn => {
                btn.addEventListener('click', handleAddToCart);
            });
            console.log(`✅ Premium Slider #${sectionId} initialized`);
        });
        
        console.log('%c✅ Premium Collection Ready', 'color:#2ecc71;font-weight:bold');
    }

    function initializeNavigation(slider) {
        const container = slider.closest('.premium-slider-container');
        const prevBtn = container.querySelector('.premium-nav-prev');
        const nextBtn = container.querySelector('.premium-nav-next');

        if (!prevBtn || !nextBtn) return;

        const cardElement = slider.querySelector('.premium-product-card');
        // Calculate the scroll amount based on card size and gap
        const cardWidth = cardElement ? cardElement.offsetWidth : 300;
        const gap = cardElement ? parseFloat(window.getComputedStyle(slider).gap) || 16 : 16;
        
        const scrollAmount = (cardWidth + gap) * 2; 

        prevBtn.addEventListener('click', () => {
            slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', () => {
            slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        updateArrowStates(slider, prevBtn, nextBtn);
        slider.addEventListener('scroll', () => {
            updateArrowStates(slider, prevBtn, nextBtn);
        });
    }

    function updateArrowStates(slider, prevBtn, nextBtn) {
        // Threshold check to enable/disable arrows when scroll reaches start/end
        const isAtStart = slider.scrollLeft <= 10;
        const isAtEnd = slider.scrollLeft >= (slider.scrollWidth - slider.offsetWidth - 10);

        prevBtn.style.opacity = isAtStart ? '0.3' : '1';
        prevBtn.style.cursor = isAtStart ? 'default' : 'pointer';
        nextBtn.style.opacity = isAtEnd ? '0.3' : '1';
        nextBtn.style.cursor = isAtEnd ? 'default' : 'pointer';
    }

    function handleAddToCart(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const form = button.closest('.premium-add-to-cart-form');
        if (!form) return;

        const variantId = form.querySelector('input[name="id"]').value;
        const originalText = button.innerHTML;
        const successColor = '#2ecc71'; 

        button.classList.add('loading');
        button.innerHTML = 'Adding...';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to add product to cart');
            return response.json();
        })
        .then(cart => {
            button.classList.remove('loading');
            button.innerHTML = '✓ Added!';
            // Note: The background color is set via CSS variables in the CSS file for a better theming approach
            button.style.backgroundColor = successColor; 
            updateCartCount(cart.item_count);
            showNotification('Product added to cart!', 'success');

            setTimeout(() => {
                button.innerHTML = originalText;
                // Reset to default color (which will be picked up by CSS based on Liquid settings)
                button.style.backgroundColor = ''; 
            }, 2000);
        })
        .catch(error => {
            console.error(error);
            button.classList.remove('loading');
            button.innerHTML = originalText;
            showNotification('Error adding to cart.', 'error');
        });
    }

    function updateCartCount(count) {
        // Placeholder function for updating a global cart icon/count
        document.querySelectorAll('[data-cart-count]').forEach(el => {
            el.textContent = count;
            el.style.display = count > 0 ? 'inline-flex' : 'none';
        });
    }

    function showNotification(message, type) {
        // Custom non-blocking notification (instead of alert())
        const notification = document.createElement('div');
        const successBg = '#2ecc71';
        const errorBg = '#ff5a5f';
        const bgColor = type === 'success' ? successBg : errorBg;

        notification.className = `premium-notification ${type}`;
        notification.textContent = message;
        notification.style.cssText = `
            position:fixed;top:20px;right:20px;padding:14px 20px;border-radius:8px;
            font-size:14px;font-weight:600;z-index:99999;color:#fff;
            background:${bgColor};
            box-shadow:0 6px 16px rgba(0,0,0,.4);
            transition: transform 0.3s ease-out, opacity 0.3s ease-out;
            transform: translateY(0); opacity: 1;
        `;
        document.body.appendChild(notification);

        setTimeout(() => {
            notification.style.transform = 'translateY(-20px)';
            notification.style.opacity = '0';
        }, 2500);

        setTimeout(() => {
            notification.remove();
        }, 3000);
    }
})();
